<template>
    <vue-final-modal
        v-model="show"
        name="refund-modal"
        classes="refund-modal vizion-modal-container"
        content-class="vizion-modal-content"
        :esc-to-close="escToClose"
    >
        <button class="close" @click="show = false">
            <img src="/img/icons/close-2.svg">
        </button>

        <h4>{{ texts.vratenie_objednavky_cislo }} {{ order.id }}</h4>
        <p class="subtitle">{{ texts.vyberte_tovar }}</p>

        <form :action="formUrl" class="theme-form" method="POST">

            <input type="hidden" name="refund" value="refund" />
            <input type="hidden" name="id" :value="order.id" />

            <input type="hidden" name="_token" v-model="csrf" />

            <ul class="list-reset products">
                 <li v-for="product in order.order_products" :key="product.id">
                    <div class="checkbox alt" v-if="product.type == 'product' || product.type == 'set'">
                        <label :for="'product'+product.id">
                            <span class="left">
                                <span class="image-wrap">
                                   <img :src="product.image_url" alt="" class="product-thumb">
                                </span>
                                <span class="text">
                                    <span class="excerpt" v-if="product.product && product.product.brand">{{ product.product.brand.name }}</span>
                                    <span class="name">{{ product.name }} </span>
                                </span>
                            </span>
                            <span class="right">
                                <span class="price">
                                    <span class="main">{{ product.price * product.tax }} {{ currency }}</span>
                                    <span class="count">{{ product.count }} ks</span>
                                </span>
                                <input v-if="product.product" type="checkbox" :name="'products['+product.product_id+']'" :id="'product'+product.id">
                                <input v-else type="checkbox" :name="'products['+product.product_id+']'" :id="'product'+product.id">
                                <span class="check">
                                   <img src="/img/icons/check-white.svg">
                                </span>
                            </span>
                        </label>
                    </div>
                </li>
            </ul>
            <div class="info-text">
                <p v-html="texts.kurier_pride_prevziat"></p>
            </div>
            <div class="input-wrap">
                <div class="select">
                    <label for="reason">{{ texts.dovod }}</label>
                       <select name="order_refund_reason_id" id="reason">
                        <option>{{ texts.vyberte_dovod }}</option>
                        <option :value="reason.id" v-for="(reason, index) in reasons" :key="index">{{ reason.name }}</option>
                    </select>
                </div>
            </div>
            <div class="input-wrap">
                <label for="iban">{{ texts.iban }}</label>
                <input type="text" name="iban" id="iban" required>
            </div>
            <button type="submit" class="button primary">
                {{ texts.vratit }}
                <img src="/img/icons/btn-arrow-right.svg" v-svg-inline>
            </button>
        </form>
    </vue-final-modal>
</template>

<script>
import { onMounted, reactive, toRefs, inject } from 'vue'

export default {

    props: ["order", "reasons", "formUrl", "texts"],

    setup(props) {

        const state = reactive({
            show: false,
            escToClose: true,
            csrf: null,
            currency: inject("currency"),
        })

        const emitter = inject('emitter')

        onMounted( () => {
            state.csrf = document.head.querySelector(
                'meta[name="csrf-token"]'
            ).content;
            emitter.on('refund-modal', () => state.show = true)
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
